export const SocialData = [
  {
    platform : "Github",
    icon : '../../../assets/github.png',
    link : "https://github.com/AhmedKhaled13281"
  },
  {
    platform : "Linkedin",
    icon : '../../../assets/linkedin.png',
    link : "https://www.linkedin.com/in/ahmed-rashad-2211a31b2/"
  },
  {
    platform : "Facebook",
    icon : '../../../assets/facebook.png',
    link : "https://www.facebook.com/cotey.ahmed1/"
  }
]
